/** EU 14 大过敏原 (Regulation EU 1169/2011) */

/**
 * 这里曾有一张 `ALLERGENS: {key, icon}[]` 表,15 个 emoji 图标(🌿🌾🦐…)加上
 * `allergenIcon()` / `formatAllergen()` 两个 helper。全部删除,原因有两条:
 *
 * 1. **零消费者** —— 真正在用的图标方案是 `AllergenBadge` 里的 SVG path 表
 *    (每个过敏原一条矢量路径 + 一组识别色),emoji 那套从被 SVG 取代后就没人调,
 *    只剩 barrel 还导出着。
 * 2. **emoji 是全局红线** —— 任何 label / 文案 / 占位都不许(CLAUDE.md)。emoji
 *    的字形由系统字体决定,同一个 🌾 在 iPad 与壁挂 Android 屏上可能完全不同,
 *    而过敏原标识必须在每块屏上长得一样。
 */

/** Get display text: i18n label for standard keys, raw text for "other:xxx" */
export function allergenLabel(key: string, t: (k: string) => string): string {
  if (key.startsWith('other:')) return key.slice(6);
  return t(`allergen.${key}`);
}
